import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

import enTranslation from "./locales/en/translation.json";
import jaTranslation from "./locales/ja/translation.json";
import zhTranslation from "./locales/zh/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
};

// Check if we're in a browser environment
const isBrowser =
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

// Configure i18n
const i18nConfig = {
  resources,
  fallbackLng: "en",
  debug: false,

  interpolation: {
    escapeValue: false, // React already does escaping
  },

  react: {
    useSuspense: false, // Disable suspense mode for better error handling
  },
};

// Only add language detection options if in browser
if (isBrowser) {
  i18nConfig.detection = {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"],
    lookupLocalStorage: "pubmed-search-language",
  };
}

// Initialize i18n with conditional plugins
i18n.use(HttpApi); // Load translations using http

// Only use LanguageDetector in browser environment
if (isBrowser) {
  i18n.use(LanguageDetector); // Detect user language
}

i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init(i18nConfig);

export default i18n;
